import { useCallback, useEffect, useState } from "react";
import styles from "./Checkbox.module.css";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const Checkbox = ({ label = "", labelPosition = "start", value = false, onChange = null, disabled = false, size = "2rem", radius = "10px", style }) => {

  const [_value, setValue] = useState(value)

  useEffect(() => setValue(value), [value])

  const handleChange = useCallback((e) => {
    if (onChange === null) return
    if (disabled) return

    setValue(!_value)

    if (onChange) {
      onChange(!_value)
    }
  }, [_value, onChange, disabled])



  return (
    <div className={disabled ? `${styles.container} ${styles.disabled}` : styles.container} style={style}>
      {
        label && labelPosition === "start" &&
        <div className={styles.label}>{label}</div>
      }
      <label className={styles.checkLabel}>
        <input type="checkbox" checked={_value} onChange={handleChange} disabled={disabled} />
        <div className={styles.checkmark}></div>
      </label>
      {
        label && labelPosition === "end" &&
        <div className={styles.label}>
          <Markdown rehypePlugins={[rehypeRaw]}>{label}</Markdown></div>
      }
    </div>
  )
}

export default Checkbox